import { render } from "./News26.vue?vue&type=template&id=4aca1f5a"
import script from "./News26.vue?vue&type=script&lang=js"
export * from "./News26.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__